module.exports = __webpack_public_path__ + "img/PAMMAccountLogo7.7761be04.svg";